import React from 'react';
import AddModalFormWrapper from './AddModalFormWrapper';
import EditFormWrapper from './EditFormWrapper';
function FormWrapper(_ref) {
  var assetContentType = _ref.assetContentType,
    isEditMode = _ref.isEditMode,
    children = _ref.children,
    isLoading = _ref.isLoading,
    isSubmitDisabled = _ref.isSubmitDisabled,
    inContentManagerContext = _ref.inContentManagerContext,
    hasChanges = _ref.hasChanges,
    onSubmit = _ref.onSubmit,
    onDiscard = _ref.onDiscard,
    onClose = _ref.onClose;
  if (isEditMode && onDiscard) {
    return /*#__PURE__*/React.createElement(EditFormWrapper, {
      isLoading: isLoading,
      isSubmitDisabled: isSubmitDisabled,
      inContentManagerContext: inContentManagerContext,
      hasChanges: hasChanges,
      onSubmit: onSubmit,
      onDiscard: onDiscard
    }, children);
  }
  return /*#__PURE__*/React.createElement(AddModalFormWrapper, {
    assetContentType: assetContentType,
    onClose: onClose,
    inContentManagerContext: inContentManagerContext,
    isLoading: isLoading,
    isSubmitDisabled: isSubmitDisabled,
    onSubmit: onSubmit
  }, children);
}
export default FormWrapper;